import { useQuery } from "react-query";
import api from "../../utils/axios";

const fetchAnalytics = async () => {

  const apiUrl = `/api/analytics`;

  const response = await api.get(apiUrl);
  return response.data?.data;
};

const useAnalytics = (address) => {
  return useQuery(
    ["analytics", address],
    ()=>fetchAnalytics(address), {
      enabled: Boolean(address), 
      cacheTime: 30,
      staleTime: 30,
      refetchOnWindowFocus: true,
      retry: 3,
      refetchOnMount: 'always',
    }
  );
};

export default useAnalytics;
